import React from 'react';
import VenueCard from './VenueCard';
import { FaSearch } from 'react-icons/fa'; // Icon for enhanced UI
import '../../components/Styles/dashboard.css'; 

const TurfGrid = ({ turfs, isLoading }) => {
  if (isLoading) {
    return <p>Loading turfs...</p>;
  }

  if (!turfs.length) {
    return (
      <div className="no-result-message">
        <FaSearch className="no-result-message__icon" />
        <p className="no-result-message__text">
          No results found. <br /> Please search for a different location or spot.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {turfs.map((turf, index) => (
        <VenueCard key={index} turf={turf} />
      ))}
    </div>
  );
};

export default TurfGrid;
